import { render, staticRenderFns } from "./ProposalReview.vue?vue&type=template&id=1acb40aa&scoped=true&"
import script from "./ProposalReview.vue?vue&type=script&lang=js&"
export * from "./ProposalReview.vue?vue&type=script&lang=js&"
import style0 from "./ProposalReview.vue?vue&type=style&index=0&id=1acb40aa&prod&lang=css&"
import style1 from "./ProposalReview.vue?vue&type=style&index=1&id=1acb40aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acb40aa",
  null
  
)

export default component.exports